// Mock data for Geo Wall and Tobermore Wall Build Up

import { BuildUpItem } from './walls-section-build-up';
export type { BuildUpItem };

export interface GeoToberWallSpecification {
  id: string;
  name: string;
  type: 'geowall' | 'tobermore';
  category: string;
  items: BuildUpItem[];
  netTotal: number;
  ohpPercent: number;
  ohpAmount: number;
  grandTotal: number;
  prelimsPercent?: number;
}

// ─── GeoWall: GPCW 600mm ────────────────────────────────────────────────────

export const geoWallGPCW600Specification: GeoToberWallSpecification = {
  id: 'geowall_gpcw600',
  name: 'GPCW 600mm',
  type: 'geowall',
  category: 'Geo Wall',
  items: [
    {
      id: 'excavate_trench',
      description: 'Excavate trench and tip on site',
      length: 0.000,
      width: 0.000,
      height: 0.000,
      net: 0.00,
      unit: 'm3',
      rate: 0.00,
      total: 0.00,
    },
    {
      id: 'compact_formation',
      description: 'Compact formation',
      length: 0.000,
      width: 0.000,
      height: 0.000,
      net: 0.00,
      unit: 'm2',
      rate: 0.00,
      total: 0.00,
    },
    {
      id: 'concrete_blinding',
      description: 'Concrete Blinding',
      net: 0.00,
      unit: 'm3',
      rate: 0.00,
      total: 0.00,
    },
    {
      id: 'a393_mesh',
      description: 'A393 Mesh',
      net: 0.00,
      unit: 'm2',
      rate: 0.00,
      total: 0.00,
    },
    {
      id: 'a252_mesh',
      description: 'A252 Mesh',
      net: 0.00,
      unit: 'm2',
      rate: 0.00,
      total: 0.00,
    },
    {
      id: 'b503_mesh',
      description: 'B503 Mesh',
      net: 0.00,
      unit: 'm2',
      rate: 0.00,
      total: 0.00,
    },
    {
      id: 'b785_mesh',
      description: 'B785 Mesh',
      net: 0.00,
      unit: 'm2',
      rate: 0.00,
      total: 0.00,
    },
    {
      id: 'concrete_to_foundation',
      description: 'Concrete to foundation',
      length: 0.000,
      width: 0.000,
      height: 0.000,
      net: 0.00,
      unit: 'm3',
      rate: 0.00,
      total: 0.00,
    },
    {
      id: 'as_dug_backfill',
      description: 'As dug Backfill',
      net: 0.00,
      unit: 'm3',
      rate: 0.00,
      total: 0.00,
    },
    {
      id: 'stockpile_onsite',
      description: 'Stockpile Onsite',
      net: 0.00,
      unit: 'm2',
      rate: 0.00,
      total: 0.00,
    },
    {
      id: 'pipe_perforated',
      description: '150mmØ perforated pipe',
      net: 0.00,
      unit: 'm',
      rate: 0.00,
      total: 0.00,
    },
    {
      id: 'concrete_haunching_front',
      description: 'Concrete haunching to front',
      length: 0.000,
      width: 0.000,
      height: 0.000,
      net: 0.00,
      unit: 'm',
      rate: 0.00,
      total: 0.00,
    },
    {
      id: 'concrete_haunching_rear',
      description: 'Concrete haunching to rear',
      length: 0.000,
      width: 0.000,
      height: 0.000,
      net: 0.00,
      unit: 'm',
      rate: 0.00,
      total: 0.00,
    },
    {
      id: 'granular_backfill',
      description: 'Granular backfill',
      length: 0.000,
      width: 0.000,
      height: 0.000,
      net: 0.00,
      unit: 'm3',
      rate: 0.00,
      total: 0.00,
    },
    {
      id: 'granular_backfill_2',
      description: 'Granular backfill',
      net: 0.00,
      unit: 'm',
      rate: 0.00,
      total: 0.00,
    },
    {
      id: 'terram',
      description: 'Terram',
      length: 0.000,
      width: 0.000,
      height: 0.000,
      net: 0.00,
      unit: 'm3',
      rate: 0.00,
      total: 0.00,
    },
    {
      id: 'fence_post',
      description: 'Fence post at 2400mm ccs',
      net: 0.00,
      unit: 'nr',
      rate: 0.00,
      total: 0.00,
    },
    {
      id: 'purchase',
      description: 'Purchase',
      net: 0.00,
      unit: 'item',
      rate: 0.00,
      total: 0.00,
    },
    {
      id: 'carriage',
      description: 'Carriage',
      net: 0.00,
      unit: 'item',
      rate: 0.00,
      total: 0.00,
    },
    {
      id: 'waste_5pct',
      description: 'Waste 5%',
      net: 0.00,
      unit: 'item',
      rate: 0.00,
      total: 0.00,
    },
    {
      id: 'fp_4pct',
      description: 'FP 4%',
      net: 0.00,
      unit: 'item',
      rate: 0.00,
      total: 0.00,
    },
    {
      id: 'install',
      description: 'Install',
      net: 0.00,
      unit: 'm2',
      rate: 0.00,
      total: 0.00,
    },
  ],
  netTotal: 0.00,
  ohpPercent: 15,
  ohpAmount: 0.00,
  grandTotal: 0.00,
};

// ─── GeoWall: GPCW 900mm ────────────────────────────────────────────────────

export const geoWallRW900Specification: GeoToberWallSpecification = {
  id: 'geowall_rw_900',
  name: 'GPCW 900mm',
  type: 'geowall',
  category: 'Geo Wall',
  items: [
    {
      id: 'excavate_trench',
      description: 'Excavate trench and tip on site',
      length: 0.000,
      width: 0.000,
      height: 0.000,
      net: 0.00,
      unit: 'm3',
      rate: 0.00,
      total: 0.00,
    },
    {
      id: 'compact_formation',
      description: 'Compact formation',
      length: 0.000,
      width: 0.000,
      height: 0.000,
      net: 0.00,
      unit: 'm2',
      rate: 0.00,
      total: 0.00,
    },
    {
      id: 'concrete_blinding',
      description: 'Concrete Blinding',
      net: 0.00,
      unit: 'm3',
      rate: 0.00,
      total: 0.00,
    },
    {
      id: 'a393_mesh',
      description: 'A393 Mesh',
      net: 0.00,
      unit: 'm2',
      rate: 0.00,
      total: 0.00,
    },
    {
      id: 'a252_mesh',
      description: 'A252 Mesh',
      net: 0.00,
      unit: 'm2',
      rate: 0.00,
      total: 0.00,
    },
    {
      id: 'b503_mesh',
      description: 'B503 Mesh',
      net: 0.00,
      unit: 'm2',
      rate: 0.00,
      total: 0.00,
    },
    {
      id: 'b785_mesh',
      description: 'B785 Mesh',
      net: 0.00,
      unit: 'm2',
      rate: 0.00,
      total: 0.00,
    },
    {
      id: 'concrete_to_foundation',
      description: 'Concrete to foundation',
      length: 0.000,
      width: 0.000,
      height: 0.000,
      net: 0.00,
      unit: 'm3',
      rate: 0.00,
      total: 0.00,
    },
    {
      id: 'as_dug_backfill',
      description: 'As dug Backfill',
      net: 0.00,
      unit: 'm3',
      rate: 0.00,
      total: 0.00,
    },
    {
      id: 'stockpile_onsite',
      description: 'Stockpile Onsite',
      net: 0.00,
      unit: 'm2',
      rate: 0.00,
      total: 0.00,
    },
    {
      id: 'pipe_perforated',
      description: '150mmØ perforated pipe',
      net: 0.00,
      unit: 'm',
      rate: 0.00,
      total: 0.00,
    },
    {
      id: 'concrete_haunching_front',
      description: 'Concrete haunching to front',
      length: 0.000,
      width: 0.000,
      height: 0.000,
      net: 0.00,
      unit: 'm',
      rate: 0.00,
      total: 0.00,
    },
    {
      id: 'concrete_haunching_rear',
      description: 'Concrete haunching to rear',
      length: 0.000,
      width: 0.000,
      height: 0.000,
      net: 0.00,
      unit: 'm',
      rate: 0.00,
      total: 0.00,
    },
    {
      id: 'granular_backfill',
      description: 'Granular backfill',
      length: 0.000,
      width: 0.000,
      height: 0.000,
      net: 0.00,
      unit: 'm3',
      rate: 0.00,
      total: 0.00,
    },
    {
      id: 'granular_backfill_2',
      description: 'Granular backfill',
      net: 0.00,
      unit: 'm',
      rate: 0.00,
      total: 0.00,
    },
    {
      id: 'terram',
      description: 'Terram',
      length: 0.000,
      width: 0.000,
      height: 0.000,
      net: 0.00,
      unit: 'm3',
      rate: 0.00,
      total: 0.00,
    },
    {
      id: 'fence_post',
      description: 'Fence post at 2400mm ccs',
      net: 0.00,
      unit: 'nr',
      rate: 0.00,
      total: 0.00,
    },
    {
      id: 'purchase',
      description: 'Purchase',
      net: 0.00,
      unit: 'item',
      rate: 0.00,
      total: 0.00,
    },
    {
      id: 'carriage',
      description: 'Carriage',
      net: 0.00,
      unit: 'item',
      rate: 0.00,
      total: 0.00,
    },
    {
      id: 'waste_5pct',
      description: 'Waste 5%',
      net: 0.00,
      unit: 'item',
      rate: 0.00,
      total: 0.00,
    },
    {
      id: 'fp_4pct',
      description: 'FP 4%',
      net: 0.00,
      unit: 'item',
      rate: 0.00,
      total: 0.00,
    },
    {
      id: 'install',
      description: 'Install',
      net: 0.00,
      unit: 'm2',
      rate: 0.00,
      total: 0.00,
    },
  ],
  netTotal: 0.00,
  ohpPercent: 15,
  ohpAmount: 0.00,
  grandTotal: 0.00,
};

// ─── Tobermore: TPCW xxxxmm ─────────────────────────────────────────────────

export const tobermoreTPCWSpecification: GeoToberWallSpecification = {
  id: 'tobermore_tpcw',
  name: 'TPCW xxxxmm',
  type: 'tobermore',
  category: 'Tobermore Walls',
  items: [
    {
      id: 'excavation_embankment',
      description: 'Excavation of embankment',
      net: 0.00,
      unit: 'm3',
      rate: 0.00,
      total: 0.00,
    },
    {
      id: 'stockpile_onsite',
      description: 'Stockpile onsite',
      net: 0.00,
      unit: 'm2',
      rate: 0.00,
      total: 0.00,
    },
    {
      id: 'batter_face_embankment',
      description: 'Batter to face of embankment',
      net: 0.00,
      unit: 'm2',
      rate: 0.00,
      total: 0.00,
    },
    {
      id: 'excavation_base',
      description: 'Excavation of base',
      net: 0.00,
      unit: 'm3',
      rate: 0.00,
      total: 0.00,
    },
    {
      id: 'stockpile_onsite_2',
      description: 'Stockpile Onsite',
      net: 0.00,
      unit: 'm2',
      rate: 0.00,
      total: 0.00,
    },
    {
      id: 'level_compact_formation',
      description: 'Level & compact formation',
      net: 0.00,
      unit: 'm2',
      rate: 0.00,
      total: 0.00,
    },
    {
      id: 'concrete_to_base',
      description: 'Concrete to base',
      net: 0.00,
      unit: 'm3',
      rate: 0.00,
      total: 0.00,
    },
    {
      id: 'tobermore_supply_grand_secura',
      description: 'Tobermore - supply of Grand Secura (incl FP)',
      net: 0.00,
      unit: 'm2',
      rate: 0.00,
      total: 0.00,
    },
    {
      id: 'tobermore_secura_install',
      description: 'Tobermore Secura installation by M&J',
      net: 0.00,
      unit: 'm2',
      rate: 0.00,
      total: 0.00,
    },
    {
      id: 'tobermore_supply_geogrid',
      description: 'Tobermore - supply of geogrid',
      net: 0.00,
      unit: 'm2',
      rate: 0.00,
      total: 0.00,
    },
    {
      id: 'mj_install_geogrid',
      description: 'M&J installation of geogrid',
      net: 0.00,
      unit: 'm2',
      rate: 0.00,
      total: 0.00,
    },
    {
      id: 'fence_post',
      description: 'Fence post at 2400mm ccs',
      net: 0.00,
      unit: 'nr',
      rate: 0.00,
      total: 0.00,
    },
    {
      id: 'free_draining_granular_backfill',
      description: 'Free draining granular backfill 300w column',
      net: 0.00,
      unit: 'm3',
      rate: 0.00,
      total: 0.00,
    },
    {
      id: 'granular_backfill_rear',
      description: 'Granular backfill to rear of wall',
      net: 0.00,
      unit: 'm3',
      rate: 0.00,
      total: 0.00,
    },
    {
      id: 'land_drain_rear',
      description: 'Land drain to rear of wall',
      net: 0.00,
      unit: 'm',
      rate: 0.00,
      total: 0.00,
    },
    {
      id: 'allow_silt_trap',
      description: 'Allow silt trap',
      net: 0.00,
      unit: 'nr',
      rate: 0.00,
      total: 0.00,
    },
    {
      id: 'connect_land_drain_plot_drainage',
      description: 'Allow to connect of land drain to plot drainage',
      net: 0.00,
      unit: 'nr',
      rate: 0.00,
      total: 0.00,
    },
  ],
  netTotal: 0.00,
  ohpPercent: 15,
  ohpAmount: 0.00,
  grandTotal: 0.00,
};

// ─── Factory: generate GPCW 750mm and GPCW 1050mm specifications ────────────

export const geoWallGPCW750Specification: GeoToberWallSpecification = {
  ...geoWallGPCW600Specification,
  id: 'geowall_gpcw750',
  name: 'GPCW 750mm',
  items: geoWallGPCW600Specification.items.map((item) => {
    const net = (item.length && item.width && item.height)
      ? parseFloat((item.length * item.width * item.height).toFixed(3))
      : 0;
    return { ...item, net, total: 0 };
  }),
};

export const geoWallGPCW1050Specification: GeoToberWallSpecification = {
  ...geoWallRW900Specification,
  id: 'geowall_gpcw1050',
  name: 'GPCW 1050mm',
  items: geoWallRW900Specification.items.map((item) => {
    const net = (item.length && item.width && item.height)
      ? parseFloat((item.length * item.width * item.height).toFixed(3))
      : 0;
    return { ...item, net, total: 0 };
  }),
};

// ─── Factory: generate 8 Tobermore TPCW specifications ──────────────────────

const TPCW_FIELD_KEYS = ['tpcw1','tpcw2','tpcw3','tpcw4','tpcw5','tpcw6','tpcw7','tpcw8'] as const;

export const tobermoreTPCWSpecifications: GeoToberWallSpecification[] = TPCW_FIELD_KEYS.map(
  (fieldKey) => ({
    ...tobermoreTPCWSpecification,
    id: `tobermore_${fieldKey}`,
    name: `TPCW xxxxmm`,
  })
);

// ─── All specifications ─────────────────────────────────────────────────────

export const geoToberWallSpecifications: GeoToberWallSpecification[] = [
  // Geo Wall (4 GPCW sizes)
  geoWallGPCW600Specification,
  geoWallGPCW750Specification,
  geoWallRW900Specification,
  geoWallGPCW1050Specification,
  // Tobermore Walls (8 dynamic TPCW columns)
  ...tobermoreTPCWSpecifications,
];

// Map from field name to specification ID
export const geoToberWallFieldToSpecId: { [key: string]: string } = {
  geoWallGPCW600: 'geowall_gpcw600',
  gpcw750: 'geowall_gpcw750',
  geoWallRW900: 'geowall_rw_900',
  gpcw1050: 'geowall_gpcw1050',
  tpcw1: 'tobermore_tpcw1',
  tpcw2: 'tobermore_tpcw2',
  tpcw3: 'tobermore_tpcw3',
  tpcw4: 'tobermore_tpcw4',
  tpcw5: 'tobermore_tpcw5',
  tpcw6: 'tobermore_tpcw6',
  tpcw7: 'tobermore_tpcw7',
  tpcw8: 'tobermore_tpcw8',
};

// Maps BuildUpItem.id to evaluate code for item library rate lookup.
// Geo Wall item codes (maps BuildUpItem.id → evaluate code for item library lookup)
export const GEO_WALL_BUILD_UP_ITEM_CODE_MAP: Record<string, string> = {
  excavate_trench:            "GWALPGW0026",
  compact_formation:          "GWALPGW0027",
  concrete_blinding:          "GWALPGW0015",
  a393_mesh:                  "GWALPRM004",
  a252_mesh:                  "GWALPRM003",
  b503_mesh:                  "GWALPRM006",
  b785_mesh:                  "GWALPRM007",
  concrete_to_foundation:     "GWALPGW0013",
  as_dug_backfill:            "GWALP034",
  stockpile_onsite:           "ALP033A",
  pipe_perforated:            "GWALPGW0024",
  concrete_haunching_front:   "GWALPGW0023",
  concrete_haunching_rear:    "GWALPGW0023",
  granular_backfill:          "GWALPGW0032",
  granular_backfill_2:        "GWALPGW0032",
  terram:                     "GWALP014",
  fence_post:                 "GWALPGW0022",
  purchase:                   "ZEV23",
  carriage:                   "",
  waste_5pct:                 "",
  fp_4pct:                    "",
  install:                    "GWALPGW0037",
};

// Tobermore item codes
export const TOBERMORE_BUILD_UP_ITEM_CODE_MAP: Record<string, string> = {
  excavation_embankment:              "GWALPGW0026",
  stockpile_onsite:                   "ALP033A",
  batter_face_embankment:             "GWALPGW0027",
  excavation_base:                    "GWALPGW0026",
  stockpile_onsite_2:                 "ALP033A",
  level_compact_formation:            "GWALPGW0027",
  concrete_to_base:                   "GWALPGW0013",
  tobermore_supply_grand_secura:      "SCAANC007",
  tobermore_secura_install:           "GWALPGW0037",
  tobermore_supply_geogrid:           "SCAANC007a",
  mj_install_geogrid:                 "ALP032B",
  fence_post:                         "GWALPGW0022",
  free_draining_granular_backfill:    "GWALPGW0032",
  granular_backfill_rear:             "GWALPGW0032",
  land_drain_rear:                    "GWALPGW0024",
  allow_silt_trap:                    "GWALPDD019",
  connect_land_drain_plot_drainage:   "GWALPDD057",
};

// Wall categories
export const geoToberWallCategories = {
  geowall: 'Geo Wall',
  tobermore: 'Tobermore Walls',
};
